module.exports = __webpack_public_path__ + "img/banc-aerial.9aa2ab3f.jpg";